module.exports = __webpack_public_path__ + "img/symbol_7.b404b58b.png";